import { render, staticRenderFns } from "./Edu.vue?vue&type=template&id=5b7787d6&"
import script from "./Edu.vue?vue&type=script&lang=js&"
export * from "./Edu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports